import { SVG } from '../SVG'

const DefaultProfileImageIcon = ({ ...props }) => (
  <SVG width='400' height='400' viewBox='0 0 400 400' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M400 0V400H0V0H400ZM198.4 85.83C152.59 87.54 127.19 140.03 154.51 177.11C177.66 208.54 225.51 207.49 247.55 175.36C274.03 136.75 245.01 84.09 198.4 85.83ZM314.67 314.29C315 280.43 293.92 249.06 263.12 235.75C252.79 231.29 241.56 229.01 230.31 228.56C211.63 227.8 189.53 227.82 170.85 228.56C159.15 229.02 147.58 231.37 136.9 236.13C106.36 249.75 86.12 280.67 86.11 314.29H314.68H314.67Z'
      fill='var(--svg-light-fill)'
    />
    <path
      d='M314.67 314.29H86.0996C86.0996 280.66 106.35 249.75 136.89 236.13C147.57 231.37 159.14 229.02 170.84 228.56C189.53 227.82 211.62 227.8 230.3 228.56C241.55 229.01 252.78 231.29 263.11 235.75C293.91 249.07 314.99 280.44 314.66 314.29H314.67Z'
      fill='var(--color-white)'
    />
    <path
      d='M198.4 85.8301C245.01 84.0901 274.03 136.75 247.55 175.36C225.51 207.49 177.66 208.54 154.51 177.11C127.19 140.03 152.59 87.5301 198.4 85.8301Z'
      fill='var(--color-white)'
    />
  </SVG>
)

export default DefaultProfileImageIcon
